function parseData(data) {
    if ((!data) || data.length == 0) {
      return null;
    } else {
      return JSON.stringify(data);
    }
  }

  function serviceFactory({ api }) {

    const getPortfolioSummary = ({ inputParam, metaData }) =>
      api.getPortfolioSummary(inputParam, metaData)
        .then(parseData)
   
  
   
    return {
        getPortfolioSummary,
      
    }
  }
  
  module.exports = serviceFactory;